import React, { useEffect, useState, useCallback } from 'react'
import {
  Input,
  Form,
  Col,
  Button,
  message,
  Table,
  Select,
  Row,
  Tooltip,
  Popconfirm,
} from 'antd'
import { EditOutlined, DeleteOutlined } from '@ant-design/icons'
import Layouts from '../../../components/Layouts'
import apiRequest from '../../../hooks/ApiRequest'

const { Option } = Select

const RiskCover = props => {
  const { form } = props
  const { getFieldDecorator } = form
  const [data, setData] = useState([])
  const [products, setProducts] = useState([])
  const [riskCover, setRiskCover] = useState([])
  const [editId, setEditId] = useState(0);
  const [selectedProductId, setSelectedProductId] = useState('');
  const LoginInsurerId = JSON.parse(localStorage.getItem('insurerId'));

  const columns = [
    {
      key: '1',
      title: 'Risk Cover Name',
      dataIndex: 'riskCoverName',
    },
    {
      key: '2',
      title: 'Product Name',
      dataIndex: 'productName',
    },
    {
      key: '3',
      title: 'Insurer Name',
      dataIndex: 'insurerName',
    },
    {
      key: '4',
      title: 'Action',
      render: (_, record) => (
        <>
          <Tooltip title="Edit">
            <Button
              type="primary"
              className="edit_btn"
              onClick={() => handleEdit(record?.riskCoverId)}>
              <EditOutlined />
            </Button>
          </Tooltip>
          <Popconfirm
            className="delete_btn"
            title="Are you sure you want to delete this record ?"
            onConfirm={() =>
              handleDeleteCover(record.riskCoverId)
            }>
            <Tooltip title="Delete">
              <Button type="danger" style={{ marginLeft: 8 }}>
                <DeleteOutlined />
              </Button>
            </Tooltip>
          </Popconfirm>
        </>
      ),
    },
  ]

  const handleDeleteCover = async (riskCoverId) => {
    try {
      const res = await apiRequest(process.env.REACT_APP_BASE_URL_INSURER + `/api/Insurer/DeactivateRiskCover/${riskCoverId}`, 'POST')

      if (res.success) {
        message.success('Risk Cover Deleted Successfully !!').then(() => {
          window.location.reload(false);
        });
      } else {
        message.error('Failed to delete risk cover.');
      }
    } catch (error) {
      console.error('Delete risk cover Error:', error)
      message.error('Failed to delete risk cover!')
    }
  }

  const fetchData = useCallback(async (productId) => {
    try {
      const prods = await apiRequest(
        process.env.REACT_APP_BASE_URL_INSURER +
        `/api/Insurer/GetInsurerProductByInsurerId/${LoginInsurerId}`,
        'GET',
      )
      const CoverList = await apiRequest(
        process.env.REACT_APP_BASE_URL_INSURER +
        '/api/Insurer/GetAllRiskCovers',
        'GET',
      )
      if (productId) {
        const covers = await apiRequest(
          process.env.REACT_APP_BASE_URL_ADMIN +
          `/Product/GetRiskCoversByProduct/get-risk-covers-by-product/${productId}`,
          'GET',
        )
        if (covers.success) setRiskCover(covers?.data?.result || [])
      }
      if (prods.success) setProducts(prods.data || [])
      if (CoverList.success) {
        const formattedData = (CoverList?.data || [])
          // filter only logged-in insurer
          .filter(item => item.insurerProduct?.insurerId === LoginInsurerId)
          .map(item => ({
            ...item,
            key: item.riskCoverId,
            riskCoverName: item.riskCoverName,
            productName: item.insurerProduct?.productName || 'N/A',
            insurerName:
              (item.insurerProduct?.insurer?.firstName || '') +
              ' ' +
              (item.insurerProduct?.insurer?.lastName || 'N/A'),
          }));

        setData(formattedData);
      }

    } catch (error) {
      message.error('Failed to fetch data.')
    }
  }, [])

  useEffect(() => {
    fetchData(selectedProductId)
  }, [fetchData, selectedProductId])

  const handleEdit = async id => {
    try {
      const response = await apiRequest(
        process.env.REACT_APP_BASE_URL_INSURER +
        `/api/Insurer/GetRiskCoverById/${id}`,
        'GET',
      )
      if (response.success) {
        const { riskCoverName, riskCoverId } = response.data
        setEditId(riskCoverId)
        form.setFieldsValue({
          riskCoverName: riskCoverName,
        })
      }
    } catch (error) {
      console.error('Error fetching insurer details:', error)
    }
  }
  const handleDelete = async id => {
    try {
      const response = await apiRequest(
        process.env.REACT_APP_BASE_URL_INSURER +
        `/api/Insurer/DeleteRiskCover/${id}`,
        'GET',
      )
      if (response.success) {
        message.success('Policy Cover Deleted Successfully !!')
        fetchData()
      } else {
        message.error('Failed to delete risk cover.')
      }
    } catch (error) {
      message.error('Network error while deleting.')
    }
  }

  const handleSubmit = async e => {
    e.preventDefault()

    try {
      const values = await form.validateFields()

      const payload = { ...values }

      const url = editId
        ? `${process.env.REACT_APP_BASE_URL_INSURER}/api/Insurer/update-insurer-riskCoverMaster/${editId}`
        : `${process.env.REACT_APP_BASE_URL_INSURER}/api/Insurer/create-insurer-riskCoverMaster`

      const response = await apiRequest(url, 'POST', payload)

      if (response.success) {
        message.success(
          editId ? 'Policy Cover Updated!' : 'Policy Cover Added!',
        )
        form.resetFields()
        setEditId(0)
        fetchData()
      } else {
        message.error(response.error || 'Something went wrong.')
      }
    } catch (err) {
      console.error(err)
      message.error('Validation failed or network error.')
    }
  }
  const handleProductChange = (value) => {
    const selected = products.find(p => p.productId === value);
    if (selected) {
      setSelectedProductId(selected.genericProductId)
    }
  };

  return (
    <Layouts title="assets" classname="dashboard">
      <div className="dash-bg-white">
        <Row gutter={[16, 16]}>
          <Col xs={12} sm={24} md={24} lg={12}>
            <div className="section-top-heading">
              <h3
                style={{ color: '#0C1362', fontWeight: '600', fontSize: '20px' }}>
                Manage Insurer Risk Cover
              </h3>
            </div>
          </Col>
        </Row>
      </div>

      <div>
        <Row className="m-t-30 m-b-40">
          <div
            className="dash-bg-white"
            style={{ padding: '20px', width: '100%' }}>
            <Form form={form} layout="vertical" onSubmit={handleSubmit}>
              <Row gutter={16}>
                {editId ? (
                  <Col md={12}>
                    <Form.Item label="Name">
                      {getFieldDecorator('riskCoverName', {
                        rules: [{ required: true, message: 'Name is required' }],
                      })(<Input placeholder="Enter Risk Cover Name" />)}
                    </Form.Item>
                  </Col>
                ) : (
                  <>
                    <Col lg={10}>
                      <Form.Item label="Select Products">
                        {getFieldDecorator('insurerProductId', {
                          rules: [
                            {
                              required: true,
                              message: 'Please select product',
                            },
                          ],
                        })(
                          <Select placeholder="Select Products" onChange={handleProductChange}>
                            {products?.map(product => (
                              <Option
                                key={product?.productId}
                                value={product?.productId}>
                                {product?.productName}
                              </Option>
                            ))}
                          </Select>,
                        )}
                      </Form.Item>
                    </Col>
                    <Col lg={10}>
                      <Form.Item label="Select Risk Cover">
                        {getFieldDecorator('riskCoverIds', {
                          rules: [
                            {
                              required: true,
                              message: 'Please select at least one risk cover',
                            },
                          ],

                        })(
                          <Select
                            mode="multiple"
                            placeholder="Select Risk Cover">
                            {riskCover?.map(product => (
                              <Option
                                key={product?.riskcoverid}
                                value={product?.riskcoverid}>
                                {product?.riskname}
                              </Option>
                            ))}
                          </Select>,
                        )}
                      </Form.Item>
                    </Col>
                  </>
                )}
                <Col lg={4}>
                  <Button
                    htmlType="submit"
                    className="primary m-t-22"
                    type="primary">
                    {editId !== 0 ? 'Update' : 'Add'}
                  </Button>
                </Col>
              </Row>
            </Form>
          </div>

          <div className="table-grid-bx" style={{ width: '100%' }}>
            <Table
              className="table-scroll-auto"
              columns={columns}
              dataSource={data}
              pagination={false}
              rowKey="riskcoverid"
            />
          </div>
        </Row>
      </div>
    </Layouts>
  )
}

export default Form.create()(RiskCover)
